import { Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfirmDialogComponent, ConfirmDialogData } from '../components/confirm-dialog/confirm-dialog.component';
import { Observable, from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  constructor(private modalService: BsModalService) {}

  show(data: ConfirmDialogData): Observable<boolean> {
    const modalRef = this.modalService.show(ConfirmDialogComponent, {
      initialState: {
        title: data.title,
        message: data.message,
        confirmText: data.confirmText || 'Yes',
        cancelText: data.cancelText || 'No'
      }
    });

    return new Observable<boolean>(observer => {
      modalRef.onHidden?.subscribe((result: boolean) => {
        observer.next(result);
        observer.complete();
      });
    });
  }
}
